import React from 'react';
import PropTypes from 'prop-types';

import largeLogo from '../../../../resources/large-logo.png';


const InputComponent = ({
  id, classes, title, hint, text, onChange,
}) => {
  if (!classes) return null;
  return (
    <label className={classes.container}>
      <input id={id} type="file" onChange={onChange} accept="image/*" />
      <img src={largeLogo} className={classes.icon} alt="logo" />
      <h4 className={classes.title}>{title}</h4>
      <p className={classes.text}>{text}</p>
      <p className={classes.hint}>{hint}</p>
    </label>
  );
};

InputComponent.propTypes = {
  id: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  hint: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default InputComponent;
